import { render, staticRenderFns } from "./aboutIntroduce.vue?vue&type=template&id=fb6f1908&scoped=true&"
import script from "./aboutIntroduce.vue?vue&type=script&lang=js&"
export * from "./aboutIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./aboutIntroduce.vue?vue&type=style&index=0&id=fb6f1908&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6f1908",
  null
  
)

export default component.exports